import React, {useEffect} from 'react';
import axios from "axios";

const CancelMail = (props) => {
    const mail = props.match.params['mail'];
    const hash = props.match.params['hash'];


    useEffect(() => {
        submit();
    }, [])


    const submit = () => {
        const token = localStorage.getItem("token");
        const headers = {"Authorization": "Token " + token}
        const obj = {
            mail: mail,
            hash: hash

        };

        axios.post('/api/mail-hash-control/', obj, {"headers": headers})
            .then(res => {
                if (res.status === 200) {
                    const data = res.data;
                    if (data.result) {
                        window.location.hash = "cancellation/true";
                    } else {
                        window.location.hash = "cancellation/false";
                    }
                } else if (res.status === 401 || res.status === 403) {

                    throw res.data;
                }
            })


    }


    return (
        <div>

        </div>
    );
}

export default CancelMail;



// WEBPACK FOOTER //
// ./src/pages/CancelMail.jsx